import productImagery from './productImagery';

export default {
  ...productImagery,
  yes: 'Yes',
  no: 'No',

  title: 'OneView 4PL',
  loginBannerInfoTitle: 'Total supply chain visibility',
  loginBannerInfoDescription:
    'Providing End to End granular visibility of your fully managed, dynamically efficient logistics chain.',
  loginFormTitle: 'Log In',
  forgotPassword: 'Forgot your password?',
  email: 'Email',
  newPasswordColumn: 'New password',
  password: 'Password',
  reset: 'Reset',
  resetPassword: 'Reset Password',
  submit: 'Submit',
  logIn: 'Log in',
  backToLogin: 'Back to login',
  rememberMe: 'Remember me?',
  footerCopyright: 'Copyright © {currentYear} GBA Technologies Ltd',
  generalError: 'Something went wrong, please try again',
  colour: 'Colour',
  manufacturer: 'Manufacturer',
  manufacturedDate: 'Manufactured Date',
  year: 'Year',

  productPipeline: 'Product Pipeline',
  go: 'Go',
  damageArea: 'Damage Area',
  location: 'Location',
  chooseLocation: 'Choose Location',
  chooseCustomer: 'Choose Customer',
  chooseInspector: 'Choose Inspector',
  chooseSites: 'Choose Sites',
  chooseModel: 'Choose Model',
  pipeline: 'Pipeline',
  byNumberOfVehicles: '(by number of vehicles)',

  vesselsSummary: 'Vessels Summary',
  vehiclePassport: 'Vehicle Passport',
  destinationCountry: 'Destination Country',
  destinationDealerCode: 'Destination Dealer Code',
  collectionHold: 'Collection Hold',
  deliveryHold: 'Delivery Hold',
  financeApproved: 'Finance Approved',
  holdAtPort: 'Hold At Port',
  destinationDealer: 'Destination Dealer',
  lineOffLocation: 'Line Off Location',

  compound: 'Compound',
  transport: 'Transport',
  vessel: 'Vessel',
  passport: 'Passport',
  pts: 'Stock Sheet',
  vin: 'VIN',
  vinTracking: 'VIN Tracking',
  customs: 'Customs',
  customer: 'Customer',
  subCustomer: 'Sub Customer',
  shippingPlan: 'Shipping Plan',
  documentTypes: 'Document Types',
  documentManagement: 'Document Management',
  adminDocumentManagement: 'Admin Document Management',
  orderSummaryAdmin: 'Order Summary Admin',
  reportsPowerBI: 'Reports',
  systemAdmin: 'System Admin',
  systemAdministration: 'System Administration',
  locations: 'Locations',
  transportUnits: 'Transport Units',
  companies: 'Companies',
  userRoles: 'User Roles',
  menu: 'Menu',
  myAccount: 'My Account',
  userProfile: 'User Profile',
  username: 'Username',
  displayName: 'Display Name',
  role: 'Role',
  inspectorAssigned: 'Inspector assigned',
  manageUsers: 'Manage Users',
  customerCustomization: 'Customer Customization',
  logOut: 'Log Out',
  checklist: 'Checklist',
  inspectionStatusAccessRules: 'Inspection Status Access Rules',
  inspectionStatusAccessRule: 'Inspection Status Access Rule',
  emailNotificationAccess: 'Email Notification Access',
  stockReconciliation: 'Stock Reconciliation',
  stockReconciliationAdmin: 'Admin',
  stockReconciliationCustomer: 'Customer',
  stockReconciliationSite: 'Site',
  stockReconciliationTime: 'Report date and time',
  stockReconciliationFile: 'Customer stock file',
  stockReconciliationUpload: 'Choose file',
  stockReconciliationCheckFile: 'Check file',
  stockReconciliationRemoveFile: 'Remove',
  stockReconciliationMatchColumns: 'Match columns',
  stockReconciliationRun: 'Reconcile',
  stockReconciliationNewRun: 'New reconciliation',
  stockReconciliationExport: 'Export',
  stockReconciliationExportFailed: 'The reconciliation could not be exported.',
  stockReconciliationFilter: 'Filter',
  stockReconciliationSave: 'Save reconciliation',
  stockReconciliationSaved: 'Reconciliation saved.',
  stockReconciliationSaveFailed: 'The reconciliation could not be saved.',
  stockReconciliationLoadFailed:
    'The saved reconciliation could not be opened.',
  stockReconciliationRunFailed: 'The reconciliation could not be completed.',
  stockReconciliationJobNotFound:
    'The reconciliation job was not found. Please try again.',
  stockReconciliationInvalidFile:
    'The file is empty or has no usable VIN values.',
  stockReconciliationChooseVin: 'Select the VIN column',
  stockReconciliationChooseColumn: 'Select a column',
  stockReconciliationVinColumn: 'VIN column',
  stockReconciliationLocationColumn: 'Location column',
  stockReconciliationModelColumn: 'Model column',
  stockReconciliationSubtitle:
    'Compare customer stock report against reconstructed OneView stock at a point in time.',
  stockReconciliationSnapshotUsed: 'Snapshot used',
  stockReconciliationSnapshotStock: 'Snapshot stock',
  stockReconciliationArrivals: 'Arrivals',
  stockReconciliationDispatches: 'Dispatches',
  stockReconciliationReconstructedStock: 'Reconstructed stock',
  stockReconciliationCustomerStock: '{customer} Stock',
  stockReconciliationOneViewStock: 'OneView Stock',
  stockReconciliationDuplicates: 'Duplicates',
  stockReconciliationMatched: 'Matched',
  stockReconciliationMatchRate: 'Match Rate',
  stockReconciliationCustomerOnly: 'Customer Only',
  stockReconciliationOneViewOnly: 'OneView Only',
  stockReconciliationDupedInSource: 'Duped in source',
  stockReconciliationDupedInOneView: 'Duped in OneView',
  stockReconciliationNotes: 'Reconciliation Notes',
  stockReconciliationSearch: 'Search by VIN, model, location…',
  stockReconciliationAllStatuses: 'All statuses',
  stockReconciliationAllLocations: 'All locations',
  stockReconciliationDiscrepanciesOnly: 'Show discrepancies only',
  stockReconciliationResult: 'Result',
  stockReconciliationVin: 'VIN',
  stockReconciliationBmwLocation: 'BMW Location',
  stockReconciliationBmwModel: 'BMW Model',
  stockReconciliationOneViewMake: 'OneView Make',
  stockReconciliationOneViewModel: 'OneView Model',
  stockReconciliationOneViewYear: 'Year',
  stockReconciliationOneViewLocation: 'OneView Location',
  stockReconciliationOneViewArrived: 'Arrived',
  stockReconciliationOneViewStatus: 'Status',
  stockReconciliationQueue: 'In progress',
  stockReconciliationNoQueue: 'No pending reconciliations.',
  stockReconciliationStatus: 'Status',
  stockReconciliationProgress: 'Progress',
  stockReconciliationMessage: 'Message',
  stockReconciliationUploading: 'Uploading {done} / {total}',
  stockReconciliationUploadStatus: 'Uploading',
  stockReconciliationPending: 'Pending',
  stockReconciliationProcessing: 'Processing',
  stockReconciliationFailed: 'Failed',
  stockReconciliationCompleted: 'Completed',
  stockReconciliationQueued: 'The file was queued for reconciliation.',
  stockReconciliationHistory: 'History',
  stockReconciliationAllCustomers: 'All customers',
  stockReconciliationAllSites: 'All sites',
  stockReconciliationSavedAt: 'Saved at',
  stockReconciliationSavedBy: 'Saved by',
  stockReconciliationOpen: 'Open',
  stockReconciliationNoHistory: 'No reconciliations yet.',
  releaseNotes: 'Release Notes',
  releaseNotesApp: 'App',
  releaseNotesAppAll: 'All',
  releaseNotesVersion: 'Version',
  releaseNotesTitle: 'Title',
  releaseNotesBody: 'Notes',
  releaseNotesAdd: 'Add',
  releaseNotesCreate: 'Create release note',
  releaseNotesEdit: 'Edit release note',
  releaseNotesSave: 'Save',
  releaseNotesPublish: 'Publish',
  releaseNotesUnpublish: 'Unpublish',
  releaseNotesPublished: 'Release note published.',
  releaseNotesUnpublished: 'Release note unpublished.',
  releaseNotesTagDraft: 'Draft',
  releaseNotesTagPublished: 'Published',
  releaseNotesDismiss: 'Dismiss',
  releaseNotesViewHistory: 'View history',
  releaseNotesLoadMore: 'Load more',
  releaseNotesHistoryFailed: 'Could not load release note history.',
  releaseNotesEmpty: 'No release notes have been published.',
  releaseNotesSaved: 'Release note saved.',
  releaseNotesSaveFailed: 'The release note could not be saved.',
  releaseNotesDeleted: 'Release note deleted.',
  releaseNotesDeleteFailed: 'The release note could not be deleted.',
  releaseNotesPopupTitle: 'What is new',
  releaseNotesBodyRequired: 'Notes are required.',
  emailNotificationTypes: 'Email Notification Types',
  allowUserToModify: 'Allow User To Modify',
  emailNotificationPreferences: 'Email Notification Preferences',
  noSelfModifiableEmailNotifications:
    'No email notification preferences are available for you to modify.',

  canView: 'View Inspection',
  canEditDamage: 'Edit Damage',
  canEditFr: 'Edit FR',
  canEditParts: 'Edit Parts',
  canUpdateDamageStatus: 'Approve Damage',
  canChangePartComponent: 'Change Damage Part',
  canChangeDamageType: 'Change Damage Type',
  canChangeSeverity: 'Change Severity',
  canChangeRepairMethod: 'Change Repair Method',
  canChangeWorkCenter: 'Change Work Centre',
  canRemoveDamageLine: 'Remove Damage',
  canChangeStatus: 'Change Inspection Status',
  nextStatuses: 'Next Statuses',
  conditionGroup: 'Condition Group',
  sortOrder: 'Sort Order',
  addNextStatus: 'Add Next Status',
  actions: 'Actions',

  functionSettings: 'Function Settings',

  compoundStorage: 'Compound Storage',
  storage: 'Storage',
  storageUtilisation: 'Storage Utilisation',
  freeSlots: 'Free Slots',
  utilisation: 'Utilisation',
  vehicle: 'Vehicle',
  numberOfVehicles: 'Number of Vehicles',
  storageChartSeriesUtilisation: 'Utilisation',
  storageChartValueAxisTitle: 'Number of Vehicles',
  userName: 'User name',
  block: 'Block',
  lane: 'Lane',
  slot: 'Slot',
  load: 'Load',
  loadNumber: 'Load Number',
  loadStatus: 'Load Status',
  requestDateTime: 'Request Date Time',
  collectionDateTime: 'Collection Date Time',
  employeeCompany: 'Employee / Company',
  reference: 'Reference',
  unitName: 'Unit Name',
  loadRequest: 'Load Request',

  manageCompanies: 'Manage Companies',
  manageTransportUnits: 'Manage Transport Units',

  manageLocations: 'Manage Locations',
  fromLocation: 'From Location',
  toLocation: 'To Location',
  despatchDate: 'Despatch Date',
  chooseDate: 'Choose Date',
  transportSummary: 'Transport Summary',
  transportCompany: 'Transport Company',
  arrivalDestination: 'Arrival Destination',
  arrivalPostCode: 'Arrival Post Code',
  fleetCode: 'Fleet Code',
  lastMechanicalInspection: 'Last Mechanical Inspection',
  lastInspection: 'Last Inspection',
  siteArrivalDate: 'Site Arrival',
  firstArrivalDate: 'First Arrival',
  mileageSourceArrival: 'Arrival',
  mileageSourceReturnInspection: 'Return',
  photoUnavailable: '(photo unavailable)',
  arrivalPhotoCaption: 'Arrival photo {number} of {total}',
  otherInspections: 'Inspections Performed',
  file: 'File',
  files: 'Files',
  functions: 'Functions',
  transaction: 'Transaction',
  transactionType: 'Transaction Type',
  transactionCode: 'Transaction Code',
  transactionDate: 'Transaction Date',
  transactionDescription: 'Transaction Description',
  statusCode: 'Status Code',
  locationId: 'Location Id',
  locationCode: 'Location Code',
  locationDescription: 'Location Description',
  capacity: 'Capacity',
  vesselTitle: 'Vessels',
  model: 'Model',
  eta: 'ETA',
  serialNumber: 'Serial Number',
  arrivalDate: 'Arrival Date',
  currentSite: 'Current Site',

  orderSummary: 'Order Summary',
  notApplicable: 'N/A',
  billOfLadingUpload: 'Bill of Lading Upload',
  selectFile: 'Select file',
  upload: 'Upload',
  uploadDocument: 'Upload Document',
  download: 'Download',
  fileIsTooLarge: 'File is too large',
  associatedDocuments: 'Associated Documents',

  documentTypeCode: 'Document Type Code',
  documentType: 'Document Type',
  isCustomerPreviewRestricted: 'Is customer preview restricted?',

  addNewDocumentType: 'Add New Document Type',
  addNew: 'Add New',
  new: 'New',
  edit: 'Edit',
  delete: 'Delete',
  unDelete: 'Un-Delete',
  assign: 'Assign',
  unassign: 'Unassign',
  details: 'Details',
  preTime: 'Pre-Time',
  pt: 'PT',
  notStarted: 'Not Started',
  complete: 'Complete',
  partsMissing: 'Parts Missing',
  inProgress: 'In Progress',
  fr: 'FR',
  frLines: 'FR Lines',
  materials: 'Materials',
  requiredPartsStillMissing: '{count} required parts still missing',
  expand: 'Expand',
  collapse: 'Collapse',

  shippingPlanAdmin: 'Shipping Plan Admin',
  uploadShippingPlan: 'Upload Shipping Plan',

  customerManagement: 'Customer Management',
  customerCode: 'Customer Code',
  customerName: 'Customer Name',
  parentCustomer: 'Parent Customer',
  features: 'Features',
  rules: 'Rules',
  icon: 'Icon',
  color1: 'Foreground Colour',
  color2: 'Background Colour',
  active: 'Active',
  receiveEmail: 'Receive Email Notifications',
  deletedTags: 'Deleted tags',

  uploadIcon: 'Upload icon',
  selectStyleColor1: 'Select style color 1',
  selectStyleColor2: 'Select style color 2',
  saveChanges: 'Save Changes',
  stageChangesToTable: 'Stage Changes to Table',
  damageStagingModeHint:
    'Staging Mode: Changes apply to session table and submit on batch Apply',
  staged: 'Staged',
  commitStatus: 'Commit Status',
  applyChangesCount: 'Apply Changes ({count})',
  unsavedDamageChangesTitle: 'Unsaved damage changes',
  unsavedDamageChangesBody:
    'Staged damage changes have not been applied. Leave this page and discard them?',
  damageChangesApplied: 'Damage changes applied',
  salesGrade: 'Sales Grade',

  userType: 'User Type',
  tmsAccess: 'TMS Access',

  inspection: 'Inspection',
  inspectionSearch: 'Inspection Search',
  inspectionInsights: 'Inspection insights',
  showInsights: 'Show insights',
  hideInsights: 'Hide insights',
  showInsightDetails: 'Show details',
  hideInsightDetails: 'Hide details',
  insightsAllSite: 'All site inspections',
  insightsCurrentResults: 'Current results',
  insightsSelectedSites: 'Selected sites',
  insightsCountsAt: 'Counts at',
  insightsInspections: 'inspections',
  insightsAverage: 'Average',
  insightsUnusuallyOld: 'Unusually old',
  insightsUnusualUnavailable: 'Unusual age unavailable',
  insightsAgeUnavailable: 'Age unavailable',
  insightsUnavailable: 'Unavailable',
  insightsNew: 'new',
  insightsNoBaseline: 'No comparable baseline',
  insightsVsLastWeek: 'vs last week',
  insightsFlowTitle: 'Performed by day',
  insightsAgeTitle: 'Open inspections - age in status',
  insightsInspected: 'Inspections performed',
  insightsAuthorised: 'Authorisations performed',
  insightsEmptyCurrentResults: 'Current results has no matching inspections.',
  insightsEmptyIntersection:
    'The selected insight and current filters have no rows in common.',
  insightsChipActive: 'Insight filter',
  insightsDrillHint: 'Cards and charts keep the pre-drill cohort.',
  question: 'Question',
  attributes: 'Attributes',
  fuel: 'Fuel',

  inspectionImages: 'Inspection Images',
  inspStatus: 'Insp.Status',
  changeInspectionStatus: 'Change inspection status',
  registration: 'Registration',
  registrationDate: 'Registration Date',
  client: 'Client',
  group: 'Group',
  inspectionId: 'Inspection ID',
  inspectedAt: 'Inspected At',
  make: 'Make',
  inspectionDate: 'Inspection Date',
  template: 'Template',
  inspector: 'Inspector',
  damage: 'Damage',
  damageExceptions: 'Damage & Exceptions',
  submitDamage: 'Submit Damage',
  createDamage: 'Create Damage',
  authoriseDamage: 'Authorise Damage',
  damageId: 'Damage ID',
  damageReference: 'Damage Reference',
  component: 'Component',
  componentSearch: 'Component Search',
  partComp: 'Part/Comp',
  sector: 'Sector',
  damageCond: 'Damage/Cond',
  damageType: 'Damage Type',
  damageCause: 'Damage Cause',
  damageCondition: 'Damage Condition',
  addDamage: 'Add Damage',
  editDamage: 'Edit Damage',
  updateDamage: 'Update Damage',
  severity: 'Severity',
  customerAuthorisation: '{customerName} Authorisation',
  gbaRepairControl: 'GBA Repair Control',
  customerEditableInformation: '{customerName} Editable Information',
  gbaEditableInformation: 'GBA Controlled Information',
  vehicleGradeImpact: 'Vehicle Grade Impact',
  gradeUpdateHint:
    'Grade and grade points update automatically as appraisal fields change.',
  gradeImpactImproves: 'improves',
  gradeImpactWorsens: 'worsens',
  gradeImpactReduce: 'reduce',
  gradeImpactIncrease: 'increase',
  gradeImpactGradeUnchanged: 'stays the same',
  gradeImpactPointsUnchanged: 'stay the same',
  gbaControlledInformation: 'GBA Controlled Information (Read Only)',
  vehicleGrade: 'Vehicle Grade',
  originalValue: 'Original',
  newValue: 'New',
  restoreOriginal: 'Restore Original',
  labourTime: 'Labour Time',
  paintTime: 'Paint Time',
  totalTime: 'Total Time',

  // Damage Line Details
  damageLineDetails: 'Damage Line Details',
  eventKey: 'Event Key',
  loadingDamageLineDetails: 'Loading damage line details...',
  failedToLoadDamageLineDetails: 'Failed to load damage line details',
  notAvailable: 'N/A',
  noDamageLineDetailsFound: 'No damage line details found for this event',
  repairMethod: 'Repair Method',
  internalGrade: 'Internal Grade',
  internalGradePoints: 'Internal Grade (Grade Points)',
  workCentre: 'Work Centre',
  responsibility: 'Responsibility',
  shortcutCode: 'Shortcut Code',
  dealer: 'Dealer',

  fault: 'Fault',
  subFault: 'Sub Fault',
  size: 'Size',
  count: 'Count',
  action: 'Action',
  note: 'Note',
  notes: 'Notes',
  mechanicalFailure: 'Mechanical Failure',
  authorizationNotes: 'Authorization Notes',
  inspectionNotes: 'Inspection Notes',
  mechanicalInspectionNotes: 'Mechanical Inspection Notes',
  noNotes: 'No Notes...',
  addNote: 'Add Note',
  frCode: 'FR code',
  labourCost: 'Labour Cost',
  partsCost: 'Parts Cost',
  totalLabour: 'Total Labour',
  paintFluids: 'Paint/Fluids',
  damageTotal: 'Damage Total',
  lineCost: 'Line Cost',
  totalPrice: 'Total Price',
  authStatus: 'Auth status',
  review: 'Review',
  claimReview: 'Claim Review',
  grading: 'Grading',
  log: 'Log',
  logs: 'Logs',
  approve: 'Approve',
  approveAll: 'Approve All',
  unApprove: 'Un-Approve',
  reject: 'Reject',
  rejectAll: 'Reject All',
  unReject: 'Un-Reject',
  approveStatusQuestion: 'Are you sure you want to approve?',
  unApproveStatusQuestion: 'Are you sure you want to un-approve?',
  rejectStatusQuestion: 'Are you sure you want to reject?',
  unRejectStatusQuestion: 'Are you sure you want to un-reject?',
  deleteRecordQuestion: 'Are you sure you want to delete this record?',
  unDeleteRecordQuestion: 'Are you sure you want to un-delete this record?',
  warning: 'Warning',
  missingAuthorization:
    'Authorization resolution is missing for some of the damage lines. Please check the damage lines and complete approval procedure.',
  damageColourLegend: 'Colour legend',
  legendBorderColour: 'Border colour',
  legendNewDamage: 'New',
  legendChangedDamage: 'Changed',
  legendDeletedDamage: 'Deleted',
  legendSelectedDamage: 'Selected',
  legendDefaultDamage: 'Default',
  legendApprovedDamage: 'Approved',
  legendRejectedDamage: 'Rejected',

  odometer: 'Odometer',
  miles: 'Miles',
  updateMileage: 'Update Mileage',
  updateRegNumber: 'Update Reg number',
  options: 'Options',
  serviceAndKeys: 'Service & Keys',
  summary: 'Summary',
  damageImages: 'Damage Images',
  status: 'Status',
  inspectionStatus: 'Inspection Status',
  inspectionType: 'Inspection Type',
  tnrStatus: 'TNR Status',
  statusDescription: 'Status Description',
  wheelsAndTyres: 'Wheels & Tyres',
  documents: 'Documents',
  charges: 'Charges',
  images: 'Images',
  addImage: 'Add Image',
  pointInTimeReports: 'Point in Time Reports',
  eventViewer: 'Event Viewer',
  mot: 'MOT',
  viewReport: 'View Report',
  brand: 'Brand',
  type: 'Type',
  condition: 'Condition',
  depth: 'Depth',
  frCodesAndPartNumbers: 'FR Codes & Part Numbers',
  frCodes: 'FR Codes',
  parts: 'Parts',
  partsFludids: 'Parts & Fluids & Paint materials',
  labour: 'Labour',
  labourType: 'Labour Type',
  supplier: 'Supplier',
  partNumbers: 'Part Numbers',
  partType: 'Part Type',
  code: 'Code/Part No',
  price: 'Price',
  cost: 'Cost',
  markup: 'Markup',
  chargePrice: 'Charge Price',

  noAccessAlert:
    'Sorry, you do not have permission to access this page, please refer to your system administrator.',

  prev: 'prev',
  next: 'next',

  unableToPreviewDocType: 'Unable to preview this document type.',
  pleaseDownloadToView: 'Please download to view.',

  ok: 'OK',
  back: 'Back',
  answer: 'Answer',
  date: 'Date',
  dateTime: 'Date & Time',
  description: 'Description',

  entity: 'Entity',
  entityReference: 'Entity Reference',

  repairMatrices: 'Repair Matrices',
  archive: 'Archive',
  swap: 'Swap',
  add: 'Add',
  import: 'Import',
  importData: 'Import Data',
  createMissingLookupValues: 'Create Missing Lookup Values',
  repairActionMatrix: 'Repair Action Matrix',
  editItem: 'Edit Item',
  addItem: 'Add Item',
  search: 'Search',
  searchItem: 'Search Item',
  select: 'Select',
  quickView: 'Quick View',
  saveQuickView: 'Save View',
  quickViewName: 'Quick View Name',
  clearAll: 'Clear All',
  addFrCode: 'Add Flat Rate Code',
  createFrCode: 'Create Flat Rate Code',
  importFile: 'Import File Details',
  fileType: 'File type should be Excel, first line should be column headers',
  acceptedFile: 'Accepted file',
  excel: 'Excel',
  save: 'Save',
  create: 'Create',
  cancel: 'Cancel',
  confirm: 'Confirm',
  dispatch: 'Dispatch',
  proceed: 'Proceed',
  section: 'Section',
  claimRef: 'Claim Ref',
  excludeReCharge: 'Exclude ReCharge',
  reviewReason: 'Review Reason',
  comment: 'Comment',
  noRegNumber: 'No Reg Number',
  regNumber: 'Reg Number',
  quantity: 'Quantity',
  site: 'Site',
  noData: 'No Data',

  // logs
  user: 'User',
  applicationName: 'Application Name',
  dataType: 'Data Type',
  dataChanges: 'Changes',
  ipAddress: 'IP Address',
  latitude: 'Latitude',
  longitude: 'Longitude',
  time: 'Time',

  statusChange: 'Status Change',
  fieldUpdate: 'Field Update',

  contactName: 'Contact name',
  address: 'Address',
  postCode: 'Post Code',
  country: 'Country',
  phoneNumber: 'Phone number',

  dynamicOperations: 'Dynamic operations',
  engineBay: 'Engine bay',
  engineRunning: 'Engine running',
  electricHybrid: 'Electric/Hybrid',
  interior: 'Interior',
  updateMechanicalInspection: 'Update Mechanical Inspection',
  cumulative: 'Cumulative',
  final: 'Final',
  gradePoints: 'Grade Points',
  gradeScore: 'Grade Score',
  age: 'Age',
  mileage: 'Mileage',
  repairCost: 'Repair cost',
  month: 'month',
  months: 'months',
  autoOK: 'Auto OK',
  autoNOK: 'Auto NOK',
  maintenanceHistory: 'Maintenance history',
  chiptuningDetected: 'Chiptuning detected',
  manualDecision: 'Manual decision',
  approveForRepair: 'Approve for repair',
  rejectForRepair: 'Reject for repair',
  approveForTNR: 'Approve for TNR',
  rejectForTNR: 'Reject for TNR',
  resendTNRPreAppraisal: 'Resend TNR Pre Appraisal',
  resendTNRPostAppraisal: 'Resend TNR Post Appraisal',
  tnrApprove: 'TNR Approved',

  createInspector: 'Create Inspector',
  inspectorCode: 'Inspector Code',
  inspectorSurname: 'Inspector Surname',
  inspectorForenames: 'Inspector Forenames',
  inspectorSite: 'Inspector Site',

  compoundJobs: 'Compound Jobs',
  jobChains: 'Job Chains',
  jobs: 'Jobs',
  batteryChecks: 'Battery Checks',
  manageJobs: 'Manage Jobs',
  jobChainTemplatesTitle: 'Job Chain Templates',
  jobChainTemplatesDescription:
    'Manage job chain templates and their versions.',
  jobChainTemplatesManageAction: 'Manage Job Chain Templates',
  jobChainTemplatesNewTemplate: 'New template',
  jobChainTemplatesCreateTitle: 'New Job Chain Template',
  jobChainTemplatesBackToTemplates: 'Back to templates',
  jobChainTemplatesLoadingCreation: 'Loading creation options',
  jobChainTemplatesRetryMetadata: 'Retry metadata',
  jobChainTemplatesCreateDenied:
    'You do not have permission to create a template.',
  jobChainTemplatesCreateSelectionRequired:
    'Select an authorized scope, Customer and Job Chain Type.',
  jobChainTemplatesCreateDetails: 'Template details',
  jobChainTemplatesSelectScope: 'Select scope',
  jobChainTemplatesSelectCustomer: 'Select Customer',
  jobChainTemplatesSelectType: 'Select type',
  jobChainTemplatesCreating: 'Creating…',
  jobChainTemplatesCreateAction: 'Create Draft',
  jobChainTemplatesScopeGlobal: 'Global',
  jobChainTemplatesScopeCustomer: 'Customer',
  jobChainTemplatesStatusDraft: 'Draft',
  jobChainTemplatesStatusActive: 'Active',
  jobChainTemplatesStatusInactive: 'Inactive',
  jobChainTemplatesViewVersion: 'View v{version}',
  jobChainTemplatesFilterScope: 'Scope',
  jobChainTemplatesFilterCustomer: 'Customer',
  jobChainTemplatesFilterType: 'Job Chain Type',
  jobChainTemplatesFilterStatus: 'Status',
  jobChainTemplatesFilterVersion: 'Exact version',
  jobChainTemplatesAllOptions: 'All',
  jobChainTemplatesClearFilters: 'Clear filters',
  jobChainTemplatesLoading: 'Loading Job Chain Templates',
  jobChainTemplatesSystemEmptyTitle: 'No templates exist yet.',
  jobChainTemplatesSystemEmptyDetail:
    'A template will appear here after it is created by an authorized workflow.',
  jobChainTemplatesFilteredEmptyTitle: 'No templates match these filters.',
  jobChainTemplatesFilteredEmptyDetail:
    'Clear the current filters to see other authorized templates.',
  jobChainTemplatesFailureTitle: 'Job Chain Templates could not be loaded.',
  jobChainTemplatesFailureDetail:
    'Try again. Your current filters and page will be preserved.',
  jobChainTemplateEditorTitle: 'Job Chain Templates',
  jobChainTemplateEditorTemplateTitle: 'Job Chain Template',
  jobChainTemplateEditorInvalidId: 'Invalid template ID.',
  jobChainTemplateEditorLoading: 'Loading template and metadata',
  jobChainTemplateEditorRetryLoading: 'Retry loading',
  jobChainTemplateEditorRequestFailed: 'The request could not be completed.',
  jobChainTemplateEditorConnectivityFailure:
    'The request could not be completed. Check connectivity and retry.',
  jobChainTemplateEditorReference: 'Reference: {correlationId}',
  jobChainTemplateEditorKeepEditing: 'Keep editing',
  jobChainTemplateEditorGraph: 'Graph',
  jobChainTemplateEditorNodeNumber: 'Node {number}',
  jobChainTemplateEditorEdgeNumber: 'Edge {number}',
  jobChainTemplateEditorEdgeCondition: 'Edge {edge}, condition {condition}',
  jobChainTemplateEditorPreservedFields: 'Preserved unsupported fields',
  jobChainTemplateEditorPublicationConfirmed:
    'Publication confirmed from server: v{version} is {status}.',
  jobChainTemplateEditorPublicationStillDraft:
    'Server confirms v{version} is still Draft. Validate this saved revision before publishing again.',
  jobChainTemplateEditorCancel: 'Cancel',
  jobChainTemplateEditorEditDraft: 'Edit Draft',
  jobChainTemplateEditorContinueEditing: 'Continue editing v{version}',
  jobChainTemplateEditorCreateDraft: 'Create Draft from Active',
  jobChainTemplateEditorDraftSaved:
    'Draft saved. Validate this revision before publishing.',
  jobChainTemplateEditorSaveDraft: 'Save Draft',
  jobChainTemplateEditorPublish: 'Publish',
  jobChainTemplateEditorInformation: 'Template information',
  jobChainTemplateEditorScope: 'Scope',
  jobChainTemplateEditorCustomer: 'Customer',
  jobChainTemplateEditorVersion: 'Version',
  jobChainTemplateEditorVersionValue: 'v{version}',
  jobChainTemplateEditorStatus: 'Status',
  jobChainTemplateEditorRevisionChanged:
    'The saved revision changed. Reload the server version before validating again.',
  jobChainTemplateEditorValidationPassed:
    'Validation passed for this saved revision.',
  jobChainTemplateEditorValidationErrors: 'Validation found errors.',
  jobChainTemplateEditorValidate: 'Validate',
  jobChainTemplateEditorDiscardDraft: 'Discard Draft',
  jobChainTemplateEditorReload: 'Reload server version',
  jobChainTemplateEditorRequestInProgress: 'Request in progress…',
  jobChainTemplateEditorUnsavedChanges: 'Unsaved changes',
  jobChainTemplateEditorSavedRevision: 'Saved revision',
  jobChainTemplateEditorDependencyUnavailable:
    'Editing is unavailable until the server data and metadata can be refreshed.',
  jobChainTemplateEditorUnsupportedReadOnly:
    'Read-only: this graph contains unsupported data.',
  jobChainTemplateEditorValidationResultsAria: 'Validation and request results',
  jobChainTemplateEditorValidationResults: 'Validation results',
  jobChainTemplateEditorWarning: 'Warning',
  jobChainTemplateEditorError: 'Error',
  jobChainTemplateEditorPublicationUncertain: 'Publication result is uncertain',
  jobChainTemplateEditorPublicationUncertainDetail:
    'Check the latest template version and publication audit before trying again.',
  jobChainTemplateEditorCheckPublication: 'Check publication status',
  jobChainTemplateEditorAcknowledgeWarnings:
    'Acknowledge warnings for this saved revision',
  jobChainTemplateEditorWorkflow: 'Workflow',
  jobChainTemplateEditorHistoryUsage: 'History and usage',
  jobChainTemplateEditorTotalJobChains: 'Total Job Chains',
  jobChainTemplateEditorRunningJobChains: 'Running Job Chains',
  jobChainTemplateEditorPreviousVersion: 'Previous published version',
  jobChainTemplateEditorViewPrevious: 'View previous publication',
  jobChainTemplateEditorPublishedBy: 'Published by',
  jobChainTemplateEditorPublishedAt: 'Published at',
  jobChainTemplateEditorResult: 'Result',
  jobChainTemplateEditorNoPublication: 'No publication recorded.',
  jobChainTemplateEditorVersionHistory: 'Version history',
  jobChainTemplateEditorNoVersionHistory: 'No version history available.',
  jobChainTemplateEditorVersionStatus: 'v{version} · {status}',
  jobChainTemplateEditorAudit: 'Audit',
  jobChainTemplateEditorNoAuditEvents: 'No audit events available.',
  jobChainTemplateEditorAction: 'Action',
  jobChainTemplateEditorActor: 'Actor',
  jobChainTemplateEditorTimeUtc: 'Time (UTC)',
  jobChainTemplateEditorReferenceColumn: 'Reference',
  jobChainTemplateEditorAuditActionCreate: 'Create',
  jobChainTemplateEditorAuditActionEdit: 'Edit',
  jobChainTemplateEditorAuditActionSave: 'Save',
  jobChainTemplateEditorAuditActionSaveGraph: 'Save graph',
  jobChainTemplateEditorAuditActionValidate: 'Validate',
  jobChainTemplateEditorAuditActionPublish: 'Publish',
  jobChainTemplateEditorAuditActionDiscard: 'Discard',
  jobChainTemplateEditorAuditActionCreateDraft: 'Create Draft',
  jobChainTemplateEditorAuditActionConflict: 'Conflict',
  jobChainTemplateEditorLeaveTitle: 'Leave with unsaved changes?',
  jobChainTemplateEditorLeaveConfirm: 'Leave without saving',
  jobChainTemplateEditorLeaveDetail: 'Your unsaved graph will be lost.',
  jobChainTemplateEditorStay: 'Stay',
  jobChainTemplateEditorReloadTitle: 'Reload server version?',
  jobChainTemplateEditorReloadConfirm: 'Reload and discard local changes',
  jobChainTemplateEditorReloadDetail:
    'This replaces your local graph with the latest saved server version.',
  jobChainTemplateEditorDiscardTitle: 'Discard Draft?',
  jobChainTemplateEditorDiscardConfirm: 'Confirm discard',
  jobChainTemplateEditorDiscardDetail:
    'This deletes the unpublished Draft and its local changes. Published versions remain available.',
  jobChainTemplateEditorPublishTitle: 'Publish v{version}?',
  jobChainTemplateEditorPublishConfirm: 'Confirm publish',
  jobChainTemplateEditorPublishedNotice: 'Published v{version}.',
  jobChainTemplateEditorPublishDetail:
    'Future Job Chains will use v{version}. The previous Active version becomes Inactive. Running Job Chains keep their bound version.',
  jobChainTemplatesRetry: 'Retry',
  jobChainTemplatesProblemCode: 'Code: {code}',
  jobChainTemplatesCorrelationId: 'Reference: {correlationId}',
  jobChainTemplatesColumnTemplate: 'Template',
  jobChainTemplateGraphSelectedProperties: 'Selected properties',
  jobChainTemplateGraphProperties: 'Properties',
  jobChainTemplateGraphSelectElement:
    'Select a node or connection on the canvas.',
  jobChainTemplateGraphJoinPolicy: 'Join policy',
  jobChainTemplateGraphJoinAnyLive: 'Any live incoming edge (OR)',
  jobChainTemplateGraphJoinAllLive: 'All live incoming edges (AND)',
  jobChainTemplateGraphDeletedMarker: 'Deleted marker',
  jobChainTemplateGraphNotSet: 'Not set',
  jobChainTemplateGraphNo: 'No',
  jobChainTemplateGraphYes: 'Yes',
  jobChainTemplateGraphConnection: 'Connection',
  jobChainTemplateGraphTargetNodeSettings: 'Target node settings',
  jobChainTemplateGraphInputFor: 'Input for {label}',
  jobChainTemplateGraphOutputFrom: 'Output from {label}',
  jobChainTemplateGraphOrJoin: 'OR join',
  jobChainTemplateGraphAndJoin: 'AND join',
  jobChainTemplateGraphStart: 'Start',
  jobChainTemplateGraphEnd: 'End',
  jobChainTemplateGraphDeleted: 'Deleted',
  jobChainTemplateGraphNodeLabel: '{label} ({index})',
  jobChainTemplateGraphTemplateJob: 'Template Job {jobTemplateId}',
  jobChainTemplateGraphMissingNode: 'Missing node',
  jobChainTemplateGraphInvalidConnection:
    'Choose two different nodes without an existing connection.',
  jobChainTemplateGraphConnectionAdded:
    'Connection added. Select it to configure conditions.',
  jobChainTemplateGraphNodeAdded:
    'Node added. Drag from its right connection point to another node.',
  jobChainTemplateGraphConditionCount: '{count} conditions',
  jobChainTemplateGraphAlways: 'Always',
  jobChainTemplateGraphEdgeAriaLabel: '{from} to {to}',
  jobChainTemplateGraphTitle: 'Workflow graph',
  jobChainTemplateGraphEditableInstructions:
    'Drag tasks in, then connect their handles.',
  jobChainTemplateGraphReadOnlyInstructions:
    'Read-only workflow. Drag nodes to arrange the view, or select to inspect.',
  jobChainTemplateGraphLayoutNotSaved: 'Layout is not saved.',
  jobChainTemplateGraphAutoLayout: 'Auto layout',
  jobChainTemplateGraphFitView: 'Fit view',
  jobChainTemplateGraphConnectFromSelected: 'Connect from selected node',
  jobChainTemplateGraphDeleteSelection: 'Delete selection',
  jobChainTemplateGraphSelectDestination:
    'Select a destination for {label} on the canvas or in the outline.',
  jobChainTemplateGraphCancelConnection: 'Cancel connection',
  jobChainTemplateGraphOutline: 'Graph outline',
  jobChainTemplateGraphTemplateJobs: 'Template Jobs',
  jobChainTemplateGraphSearchTemplateJobs: 'Search Template Jobs',
  jobChainTemplateGraphAddTaskInstructions:
    'Drag a task onto the canvas, or click to add it.',
  jobChainTemplateGraphAddJob: 'Add {name}',
  jobChainTemplateGraphUnsupportedJobType: 'Unsupported job type: {jobType}',
  jobChainTemplateGraphUnsupported: 'Unsupported',
  jobChainTemplateGraphSelected: 'Selected',
  jobChainTemplateGraphNodes: 'Nodes',
  jobChainTemplateGraphEdges: 'Edges',
  jobChainTemplateGraphRemoveNode: 'Remove {label}',
  jobChainTemplateGraphRemoveEdge: 'Remove edge {from} to {to}',
  jobChainTemplateGraphWorkflowAriaLabel:
    'Workflow: {nodes} nodes, {edges} directed edges',
  jobChainTemplateGraphReactFlowNodeDescription:
    'Press Enter or Space to select a node. Use the arrow keys to move it and press Delete to remove it.',
  jobChainTemplateGraphReactFlowNodeKeyboardDisabled:
    'Press Enter or Space to select a node.',
  jobChainTemplateGraphReactFlowNodeMoved:
    'Moved selected node {direction}. New position, x: {x}, y: {y}',
  jobChainTemplateGraphDirectionLeft: 'left',
  jobChainTemplateGraphDirectionRight: 'right',
  jobChainTemplateGraphDirectionUp: 'up',
  jobChainTemplateGraphDirectionDown: 'down',
  jobChainTemplateGraphReactFlowEdgeDescription:
    'Press Enter or Space to select an edge. Press Delete to remove it.',
  jobChainTemplateGraphReactFlowControls: 'Viewport controls',
  jobChainTemplateGraphReactFlowZoomIn: 'Zoom in',
  jobChainTemplateGraphReactFlowZoomOut: 'Zoom out',
  jobChainTemplateGraphReactFlowFitView: 'Fit view',
  jobChainTemplateGraphReactFlowToggleInteractivity: 'Toggle interactivity',
  jobChainTemplateGraphReactFlowMinimap: 'Mini map',
  jobChainTemplateGraphReactFlowHandle: 'Connection handle',
  jobChainTemplateGraphEmptyEditable:
    'Drag your first task here to start the workflow.',
  jobChainTemplateGraphEmptyReadOnly: 'This template has no nodes.',
  jobChainTemplateGraphRemoveNodeTitle: 'Remove node and connected edges?',
  jobChainTemplateGraphRemoveNodeConfirm: 'Remove node and edges',
  jobChainTemplateGraphRemoveNodeDescription:
    'Removing {label} also removes {count} connected edges and their conditions.',
  jobChainTemplateGraphFieldGraph: 'graph',
  jobChainTemplateGraphFieldNode: 'node',
  jobChainTemplateGraphFieldEdge: 'edge',
  jobChainTemplateGraphFieldCondition: 'condition',
  jobChainTemplateGraphUnsupportedField: 'Unsupported {label} field: {key}',
  jobChainTemplateGraphUnsupportedJoinPolicy:
    'Unsupported join policy: {joinPolicy}',
  jobChainTemplateGraphTemplateJobUnavailable:
    'Template Job {jobTemplateId} is unavailable.',
  jobChainTemplateGraphUnsupportedConditionDefinition:
    'Unsupported condition definition: {name} {condition}',
  jobChainTemplatesColumnScope: 'Scope / Customer',
  jobChainTemplatesColumnActive: 'Active',
  jobChainTemplatesColumnDraft: 'Draft',
  jobChainTemplatesColumnUsage: 'Usage',
  jobChainTemplatesColumnUpdated: 'Updated',
  jobChainTemplatesColumnVersion: 'Version',
  jobChainTemplatesColumnStatus: 'Status',
  jobChainTemplatesColumnCreated: 'Created',
  jobChainTemplatesUsage: '{total} total · {running} running',
  jobChainTemplatesVersion: 'v{version}',
  jobChainTemplateConditionTitle: 'Edge conditions',
  jobChainTemplateConditionAlwaysContinue: 'Always continue',
  jobChainTemplateConditionNoConditions:
    'This connection has no additional conditions.',
  jobChainTemplateConditionContinueWhen: 'Continue when',
  jobChainTemplateConditionShowFullRule: 'Show full rule',
  jobChainTemplateConditionAnd: 'AND',
  jobChainTemplateConditionOr: 'OR',
  jobChainTemplateConditionAll: 'ALL',
  jobChainTemplateConditionMatchAll: 'Match all conditions',
  jobChainTemplateConditionRemoveAlternativeAria: 'Remove alternative {index}',
  jobChainTemplateConditionFieldAria: 'Field {index}',
  jobChainTemplateConditionOperatorAria: 'Operator {index}',
  jobChainTemplateConditionValueAria: 'Value {index}',
  jobChainTemplateConditionNoValueNeeded: 'No value needed',
  jobChainTemplateConditionNullValue: '(null)',
  jobChainTemplateConditionChooseValues: 'Choose values',
  jobChainTemplateConditionChooseValue: 'Choose a value',
  jobChainTemplateConditionRemoveAria: 'Remove condition {index}',
  jobChainTemplateConditionMoveToAlternative: 'Move to alternative {index}',
  jobChainTemplateConditionMoveToNewAlternative:
    'Move to a new alternative (OR)',
  jobChainTemplateConditionMoreActionsAria:
    'More actions for condition {index}',
  jobChainTemplateConditionAddToAlternativeAria:
    'Add condition to alternative {index}',
  jobChainTemplateConditionAddAnd: 'Add condition (AND)',
  jobChainTemplateConditionAddAlternative: 'Add alternative (OR)',
  jobChainTemplateConditionAdd: 'Add condition',
  jobChainTemplateConditionFieldEngineType: 'Engine type',
  jobChainTemplateConditionFieldTransportMode: 'Transport mode',
  jobChainTemplateConditionFieldBatteryHVChargeRequired:
    'HV battery charge required',
  jobChainTemplateConditionFieldBattery12VChargeRequired:
    '12V battery charge required',
  jobChainTemplateConditionOperatorEquals: 'is',
  jobChainTemplateConditionOperatorNotEquals: 'is not',
  jobChainTemplateConditionOperatorGreaterThan: 'is greater than',
  jobChainTemplateConditionOperatorGreaterOrEqual: 'is at least',
  jobChainTemplateConditionOperatorLessThan: 'is less than',
  jobChainTemplateConditionOperatorLessOrEqual: 'is at most',
  jobChainTemplateConditionOperatorContains: 'contains',
  jobChainTemplateConditionOperatorNotContains: 'does not contain',
  jobChainTemplateConditionOperatorStartsWith: 'starts with',
  jobChainTemplateConditionOperatorEndsWith: 'ends with',
  jobChainTemplateConditionOperatorIn: 'is one of',
  jobChainTemplateConditionOperatorNotIn: 'is not one of',
  jobChainTemplateConditionOperatorIsNull: 'is not set',
  jobChainTemplateConditionOperatorIsNotNull: 'is set',
  jobChainTemplateConditionAlways: 'Always',
  jobChainTemplateConditionNotSet: '(not set)',
  jobChainTemplateConditionSummaryWithoutValue: '{field} {operator}',
  jobChainTemplateConditionSummaryWithValue: '{field} {operator} {value}',
  jobChainTemplateConditionSummaryGroup: '({conditions})',
  jobChainTemplatesNotAvailable: '—',
  loadLane: 'Load Lane',
  commandCentre: 'Command Centre',
  ccSelectSite: 'Select site',
  ccWho: 'Who',
  ccWhat: 'What',
  ccUpdate: 'Update',
  ccWhen: 'When',
  ccHideLiveUpdates: 'Hide Live Updates',
  ccNoLiveUpdates: 'No live updates',
  ccNoCameras: 'No cameras',
  ccGoLive: 'Go live',
  ccViewOnMap: 'View on map',
  ccHideTable: 'Hide Table',
  ccComingSoon: 'Coming soon',
  ccWeakLink: '(weak link)',
  ccSatellite: 'Satellite',
  ccStreet: 'Street',
  ccShowCameras: 'Show Security Cameras',
  ccHideCameras: 'Hide Security Cameras',
  ccLoading: 'Loading…',
  ccCollapse: 'Collapse',
  ccExpand: 'Expand',
  ccName: 'Name',
  ccStatus: 'Status',
  ccWorkrate: 'Workrate',
  ccJobsCompleted: 'Jobs Completed',
  ccCurrentStatus: 'Current Status',
  ccMetresCovered: 'Metres Covered',
  ccWorkToRestRatio: 'Work To Rest Ratio',
  ccOperator: 'Operator',
  ccSendVoicenote: 'Send a voicenote',
  ccMakeCall: 'Make a call',
  ccStartChat: 'Start a chat',
  ccAllocateJob: 'Allocate a job',
  ccAssignJob: 'Assign job',
  ccAssignJobToOperator: 'Assign job: {operator}',
  ccAssignJobTitle: 'Assign Job to {operator}',
  ccSearchJobs: 'Search by Job ID or VIN',
  ccJobId: 'Job ID',
  ccJobType: 'Job type',
  ccVin: 'VIN',
  ccCreated: 'Created',
  ccCurrentOwner: 'Current owner',
  ccAction: 'Action',
  ccAllJobTypes: 'All job types',
  ccAssign: 'Assign',
  ccTotalJobs: 'Total {total} jobs',
  ccAlreadyAssignedTo: 'Already assigned to {owner}',
  ccAssigned: 'Assigned',
  ccAssignJobAria: 'Assign Job {jobId}',
  ccReassignJobAria: 'Reassign Job {jobId}',
  ccConfirmAssignment: 'Confirm assignment',
  ccAssignConfirmation: 'Assign Job {jobId} to {newOwner}?',
  ccReassignConfirmation:
    'Reassign Job {jobId} from {previousOwner} to {newOwner}?',
  ccJobAssignedSuccess: 'Job assigned successfully.',
  ccAssignmentConflict:
    'This Job changed before it could be assigned. The list has been refreshed.',
  ccAssignmentFailed: 'The Job could not be assigned.',
  ccLiveConnected: 'Live connected',
  ccLiveConnecting: 'Connecting…',
  ccLiveReconnecting: 'Reconnecting…',
  ccLiveFailed: 'Live connection failed',
  ccEventTypeParking: 'Parking',
  ccEventTypeArrival: 'Arrival',
  ccEventTypeDispatch: 'Dispatch',
  ccEventTypeFilter: 'Event types',
  ccOnline: 'Online',
  ccOffline: 'Offline',

  engineType: 'Engine type',
  Battery12V: '12V Battery requires maintenance?',
  HVBattery: 'HV Battery requires attention?',
  howManyKeys: 'How many keys are present with the vehicle?',

  located: 'Located',
  locatedAt: 'Located at',
  lastScan: 'Last Scan',
  lastScanned: 'Last Scanned',

  'eventType.cameraScan': 'Camera Scan',
  'eventType.located': 'Located',
  'eventType.newArrival': 'New Arrival',
  'eventType.usedArrival': 'Used Arrival',
  'eventType.trackingLabelUpdated': 'Tracking Label Updated',
  'eventType.fprInspection': 'FPR Inspection',
  'eventType.mechanicalInspection': 'Mechanical Inspection',
  'eventType.returnInspectionDamage': 'Return Inspection — Damage',
  'eventType.returnInspectionVehicle': 'Return Inspection — Vehicle',
  'dashboard.title': 'Operations Dashboard',
  'dashboard.refresh': 'Refresh',
  'dashboard.status.other': 'Other',
  'dashboard.kpi.vesselArrivals': 'Vessel Arrivals',
  'dashboard.kpi.vehicleArrivals': 'Vehicle Arrivals',
  'dashboard.kpi.stockInCompounds': 'Vehicles in Stock',
  'dashboard.kpi.loadsSubmitted': 'Loads Submitted for Collection',
  'dashboard.kpi.loadsPulled': 'Loads Pulled into Collection Lanes',
  'dashboard.kpi.vehicleDespatches': 'Vehicle Despatches',
  'dashboard.kpi.vsLastWeek': 'vs {value} last week',
  'dashboard.kpi.noBaseline': 'no baseline',
  'dashboard.state.empty': 'No data for this period',
  'dashboard.state.error': 'Could not load this widget',
  'dashboard.state.retry': 'Retry',
  'dashboard.sampleData': 'Sample data',
  'dashboard.widget.trend': 'Arrivals vs Despatches vs Stock',
  'dashboard.widget.stockByCompound': 'Compound Capacity Utilisation',
  'dashboard.widget.stockByModel': 'Cars on Site by Model',
  'dashboard.widget.stockByStatus': 'Vehicle Status Distribution',
  'dashboard.widget.loadPulling': 'Load Pulling Overview',
  'dashboard.widget.maintenance': 'Maintenance Events',
  'dashboard.widget.heatmap': 'Compound Event Heatmap',
  'dashboard.heatmap.less': 'Less',
  'dashboard.heatmap.more': 'More',
  'dashboard.heatmap.events': 'events',
  'dashboard.widget.trackingMap': 'Compound Tracking Map',
  'dashboard.trend.arrivals': 'Arrivals',
  'dashboard.trend.despatches': 'Despatches',
  'dashboard.trend.stock': 'Stock',
  'dashboard.loadPulling.selectCustomer': 'Select customer',
  'dashboard.loadPulling.allCustomers': 'All customers',
  'dashboard.loadPulling.selectSite': 'Select site',
  'dashboard.loadPulling.vehiclesPulled': 'Vehicles pulled into lanes',
  'dashboard.loadPulling.planned': 'planned',
  'dashboard.loadPulling.lanes': 'lanes',
  'dashboard.loadPulling.activeLoads': 'Active Loads',
  'dashboard.loadPulling.awaitingDespatch': 'Awaiting Despatch',
  'dashboard.loadPulling.loadsPulledToday': 'Loads Pulled Today',
  'dashboard.loadPulling.vehiclesPulledToday': 'Vehicles Pulled Today',
  'dashboard.loadPulling.viewAll': 'View all {count} lanes',
  'dashboard.loadPulling.needsAttention': 'Needs attention',
  'dashboard.loadPulling.overdueBy': 'Overdue {duration}',
  'dashboard.loadPulling.dueIn': 'Due in {duration}',
  'dashboard.loadPulling.dueNow': 'Due now',
  'dashboard.loadPulling.moreAtRisk': '+{count} more lanes need attention',
  'dashboard.loadPulling.atRiskSummary': '{atRisk} of {total} lanes at risk',
  'dashboard.loadPulling.allClear': 'All lanes on track',
  'dashboard.maintenance.type': 'Maintenance Type',
  'dashboard.maintenance.requested': 'Requested (last 6 weeks)',
  'dashboard.maintenance.performed': 'Performed (last 6 weeks)',
  'dashboard.maintenance.requestedShort': 'Requested',
  'dashboard.maintenance.performedShort': 'Performed',
  'dashboard.maintenance.gap': 'Gap',
  'dashboard.trackingMap.placeholder':
    'Killingholme site drawing - vehicle route overlay',
  'dashboard.trackingMap.zones': 'zones',
  'dashboard.trackingMap.current': 'current',

  questionnaires: 'Questionnaires',
  questionnairesMenuResponses: 'Responses',
  questionnairesMenuTemplates: 'Templates',
  questionnaireResponses: 'Questionnaire Responses',
  questionnaireTemplates: 'Questionnaire Templates',
  responseId: 'Response ID',
  submittedAt: 'Submitted At',
  submittedBy: 'Submitted By',
  stockId: 'Stock ID',
  noQuestionnaireResponses: 'No questionnaire responses found',
  close: 'Close',
  commsRecordVoiceNote: 'Record voice note',
  commsStopRecording: 'Stop recording',
  commsMicrophoneDenied: 'Microphone permission was denied.',
  commsRequestingMicrophone: 'Requesting microphone access...',
  commsRecordingFailed: 'Voice recording could not be started.',
  commsVoiceUploadFailed: 'Voice note could not be sent.',
  commsMessageSending: 'Sending',
  commsMessageFailed: 'Message could not be sent.',
  commsRetryMessage: 'Retry message',
  commsMediaUnavailable: 'Media is unavailable.',
  commsPlayVoiceNote: 'Play voice note',
  commsPauseVoiceNote: 'Pause voice note',
  commsVoiceWaveform: 'Voice waveform',
  commsConversation: 'Conversation',
  commsChatWith: 'Chat with',
  commsConnectedFromTmsMobile: 'Connected from TMS mobile',
  commsMinimizeConversation: 'Minimize conversation',
  commsCloseConversation: 'Close conversation',
  commsConversationLoading: 'Loading conversation...',
  commsConversationUnavailable: 'Conversation is unavailable.',
  commsNoMessages: 'No messages yet.',
  commsMessagePlaceholder: 'Write a message',
  commsMessageSendFailed: 'Message could not be sent.',
  commsAttachImage: 'Attach image',
  commsImageSendFailed: 'Image could not be sent.',
  commsRetryImage: 'Retry',
  commsRemoveImage: 'Remove image',
  commsRemoveAllImages: 'Remove all images',
  commsSendImages: 'Send images',
  commsImagesReady:
    '{count, plural, one {# image ready} other {# images ready}}',
  commsImageUploadProgress: 'Image upload progress',
  commsDropImages: 'Drop images here',
  commsUnsupportedImage: 'Only JPEG, PNG, and WebP images are supported.',
  commsFinishVoiceBeforeImages:
    'Finish or cancel the voice message before attaching images.',
  commsFinishImagesBeforeVoice:
    'Send or remove the attached images before recording a voice message.',
  commsVoiceActivityInProgress:
    'Finish or cancel the current voice message before recording another.',
  'commsMediaPhase.processing': 'Processing image...',
  'commsMediaPhase.uploading-original': 'Uploading image...',
  'commsMediaPhase.uploading-thumbnail': 'Uploading preview...',
  'commsMediaPhase.uploading-voice': 'Uploading voice note...',
  'commsMediaPhase.sending': 'Sending...',
  commsMediaLoading: 'Loading media...',
  commsRetryMedia: 'Retry',
  commsOpenImagePreview: 'Open image preview',
  commsDownloadImage: 'Download image',
  commsRecordingVoice: 'Recording voice message',
  commsRecordingInProgress: 'Recording...',
  commsCancelRecording: 'Cancel',
  commsStopAndSendVoice: 'Stop and send',
  commsVoiceNoteStatus: 'Voice note status',
  commsDiscardVoiceNote: 'Discard',
  commsRetryVoiceNote: 'Retry send',
  'commsVoicePhase.processing': 'Processing voice note...',
  'commsVoicePhase.uploading-voice': 'Uploading voice note...',
  'commsVoicePhase.sending': 'Sending voice note...',
  commsVoiceUploadProgress: 'Voice upload progress',
  commsLoadEarlierMessages: 'Load earlier messages',
  commsLoadingEarlierMessages: 'Loading earlier messages...',
  commsBeginningOfConversation: 'Beginning of conversation',
  commsCallStart: 'Start voice call',
  commsCallIncoming: 'Incoming voice call',
  commsCallConnecting: 'Connecting voice call...',
  commsCallActive: 'Voice call active',
  commsCallEnding: 'Ending voice call...',
  commsCallFailed: 'Voice call could not be connected.',
  commsCallAccept: 'Accept call',
  commsCallDecline: 'Decline call',
  commsCallReturn: 'Return to conversation',
  commsCallHangUp: 'Hang up',
  commsConnecting: 'Connecting conversations...',
  commsReconnecting: 'Reconnecting conversations...',
  commsConnectionFailed: 'Conversations are unavailable.',
  commsRetryConnection: 'Retry',
  commsOpenConversation: 'Open conversation',
  commsGlobalInbox: 'Notifications and chats',
  commsNotifications: 'Notifications',
  commsChats: 'Chats',
  commsNoConversations: 'No conversations yet.',
  commsChatsUnavailable: 'Chats are unavailable.',
  commsImageMessage: 'Image',
  commsVoiceMessage: 'Voice message',
  commsCallCompleted: 'Call · {duration}',
  commsCallDeclined: 'Call declined',
  commsCallCancelled: 'Call cancelled',
  commsCallMissed: 'Missed call',
  commsCallNoAnswer: 'No answer',
  commsCallBusy: 'Busy',
  commsCallRecordFailed: 'Call failed',
  notificationSettings: 'Notification settings',
  notificationDesktop: 'Desktop notifications',
  notificationPreviews: 'Show message previews',
  notificationSounds: 'Alert sounds',
  notificationPermissionDenied:
    'Desktop notifications are blocked. Enable them in your browser settings.',
  notificationIncomingCall: 'Incoming call from {name}',
  removedFromAppraisal: 'Removed',
  removedAppraisalBanner: '{count} removed from active appraisal',
  removedAppraisalBody:
    'The damage line has been removed from the active appraisal. It remains visible for audit history and does not change the inspection status.',
  resubmittedBanner: 'This inspection has been resubmitted by GBA.',
  resubmittedBody: 'Review the highlighted amended line(s).',
  ptReviewBanner:
    'This inspection has been returned to Inspected following a customer amendment.',
  ptReviewBannerBody: 'Pre-timing review is required for affected items.',
  inspectionStatusChanged: 'Inspection status changed',
  backToInspectionsSoon: 'Will back to inspections page soon.',
  damageClassificationUpdated: 'Damage classification updated',
  classificationClearedPreTiming:
    'Damage classification updated. Pre-timing was removed for the amended line.',
  ptReviewInternalOnly: 'Only GBA users can resolve pre-timing review.',
  allDamage: 'All Damage',
  requiresReview: 'Requires Review',
  completedLines: 'Completed',
  damageItemsCount: '{count} damage items',
  removedAppraisalCount: '{count} removed from appraisal',
  reviewItemsCount: '{count} require review',
  amendedSinceLastReview: 'Amended',
  ptReviewRequired: 'Pre-Timing Review Required',
  bmwAmendment: 'Customer amendment',
  customerAmendment: 'Customer amendment',
  repairMethodChange: 'Repair Method: {from} → {to}',
  currentPreTiming: 'Current Pre-Timing',
  isPreTimingCorrect: 'Is the current pre-timing correct?',
  keepPreTiming: 'Yes – Keep Pre-Timing',
  removePreTiming: 'No – Remove Pre-Timing',
  ptReviewBlocksProgress:
    'The inspection cannot progress while PT Review Required items remain unresolved.',
  discardUnsavedChanges: 'Discard unsaved changes?',
  discardUnsavedChangesBody:
    'Unsaved changes will be lost if you close this form.',
  shortcutSaveNotes: '{shortcut} saves',
  recommendation: 'Recommendation',
  preTimeAssistant: 'Pre-Time Assistant',
  preTimeAssistantBody:
    "We've analysed this inspection using similar repairs from the last {years} years and found suggestions for {count} damage lines.",
  preTimeReadyToReview: 'Ready to review',
  preTimeCheckSuggestions: 'Check suggestions',
  preTimeNotEnoughHistory: 'Not enough historical data',
  preTimeSuggestedTitle: 'Suggested Pre-Time',
  preTimeBasedOn:
    'Based on {sampleSize} similar damage lines from the last {years} years.',
  preTimeCode: 'Code',
  preTimeUsage: 'Usage',
  preTimeFrCodes: 'FR Codes ({count} suggested)',
  preTimePartsCount: 'Parts ({count} suggested)',
  preTimeMaterialsCount: 'Materials ({count} suggested)',
  preTimeNoFrCodes: 'No FR codes suggested.',
  preTimeNoParts:
    'No parts commonly used for this repair type in historical data.',
  preTimeNoMaterials:
    'No materials commonly used for this repair type in historical data.',
  preTimeWhyTitle: 'Why these suggestions?',
  preTimeSimilarLines: '{count} similar damage lines found',
  preTimeWhyHighUsage: 'These items were used in 90%+ of matching repairs.',
  preTimeHistoricalUsage: 'Historical Usage',
  preTimeNoHistorical: 'No historical usage records for this repair.',
  preTimeTopCombinations: 'Top combinations found:',
  preTimeViewAllMatches: 'View all {count} historical matches',
  preTimeItemUsageTitle: 'Item usage details',
  preTimeItemUsage: '{code} usage details',
  preTimeUsageBadge: '{percent}% usage',
  preTimeUsedInRepairs: 'Used in {usedOn} of {sampleSize} similar repairs',
  preTimeWhereUsed: 'Where this was used',
  preTimeCommonlyUsedWith: 'Commonly used with',
  preTimeMakeModel: 'Make / Model',
  preTimeStatsFootnote:
    'These statistics are based on the last {years} years of OneView inspection and pre-timing data.',
  preTimeClearSuggestions: 'Clear Suggestions',
  preTimeSuggestions: 'Pre-time suggestions',
  reviewAllSuggestions: 'Review all suggestions',
  preTimeHighConfidence: 'High Confidence',
  preTimeNeedReview: 'Needs Review',
  preTimeManual: 'Manual Pre-Time',
  preTimeUsedOn: 'Used on {usedOn} of {sampleSize} lines',
  preTimeMatchedOn: 'Matched on {attributes}',
  preTimeManualBody: 'Enter this line manually.',
  preTimeAssignFr: 'FR code',
  preTimeAssignRequired:
    'Assign an FR code to each selected part or material, or clear that selection, before applying.',
  preTimeApplySelected: 'Apply selected',
  preTimeNoReviewLines: 'No high-confidence or need-review lines to review.',
  preTimeFlatRates: 'Flat rate and labour',
  preTimeParts: 'Parts',
  preTimeMaterials: 'Materials',
  preTimeAttributeCustomer: 'Customer',
  preTimeAttributeMake: 'Make',
  preTimeAttributeModel: 'Model',
  preTimeAttributeDamageArea: 'Damage Area',
  preTimeAttributeDamageType: 'Damage Type',
  preTimeAttributeRepairAction: 'Repair Action',
  preTimeApplied: 'Selected items were added to the damage line.',
  preTimePrevious: 'Previous',
  preTimeNext: 'Next',
  preTimeEvidence: 'Evidence',
  preTimeSample: '{sampleSize} matching lines',
};
